//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

export default {
    created: function created() {
        var _this = this;

        if (process.client) {
            var fullPathParts = this.$route.fullPath.split('?');
            fullPathParts.shift();
            var queryString = fullPathParts.join('?');

            var thisRef = this;
            axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/tpay/subscription-check?' + queryString).then(function (res) {
                if (res.data) {
                    _this.$auth.setToken(res.data.access_token, res.data.refresh_token, res.data.token_type, res.data.expires_in);
                    _this.$parent.$emit('login-logout-event');
                }
                _this.$router.push({ name: 'lang-successful-signup', params: { lang: _this.lang } });
            });
        }
    },


    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/subscription-check.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/subscription-check.vue
// module chunks = 48